<ng-container
  *ngIf="{
    schedules: exportSchedules$ | async,
    loading: loading$ | async,
    formMode: formMode$ | async,
    schedule: schedule$ | async,
  } as data"
>
  <app-loading *ngIf="data.loading" [size]="'3x'"></app-loading>
  <div class="card-container schedules" *ngIf="!data.loading && !data.formMode">
    <div *ngIf="data.schedules?.length === 0" class="no-schedules">
      {{
        "object-schdules.message.the-feed-dashboard-does-not-have-a-configured-schedule"
          | translate
      }}
    </div>

    <app-schedule-card
      *ngFor="let schedule of data.schedules; trackBy: trackById"
      [schedule]="schedule"
      (editSchedule)="scheduleEdit($event)"
      (deleteSchedule)="delete($event)"
    ></app-schedule-card>

    <app-object-card-placeholder
      [action]="create.bind(this)"
      [type]="'schedule'"
      class="card-placeholder"
      style="width: 100%"
    ></app-object-card-placeholder>
  </div>

  <div class="editor-container" *ngIf="data.formMode">
    <app-export-settings
      #exportSettings
      [exportSchedule]="data.schedule"
      [formMode]="data.formMode"
      [objectId]="objectId"
      [objectClassId]="objectClassId"
    ></app-export-settings>
  </div>
</ng-container>
